export default __webpack_public_path__ + "static/media/canada-prohibited.b79e0268.png";